import React from "react";
import PropTypes from "prop-types";
export const Message = ({ children, error, className, centered, }) => {
    const classes = [
        "tnic-message",
        error && "error",
        centered !== false && "centered",
        className,
    ].filter(Boolean);
    return (React.createElement("div", { className: classes.join(" ") },
        React.createElement("div", { className: "content" }, children)));
};
Message.propTypes = {
    children: PropTypes.node,
    boolean: PropTypes.bool,
    classNames: PropTypes.arrayOf(PropTypes.string),
};
//# sourceMappingURL=Message.js.map